import { defineStore } from 'pinia'
import membershipQuery from '../apollo/queries/pages/membership.gql'

export const useMembershipStore = defineStore('membership', {
  state: () => ({
    data: {}
  }),
  getters: {
    getData: (state) => {
      return state.data.membership ? state.data.membership.data.attributes : null
    }
  },
  actions: {
    async requestData() {
      if (Object.keys(this.data).length !== 0) return

      const { data } = await useAsyncQuery(membershipQuery) // eslint-disable-line no-undef

      if (data) this.data = data
    }
  }
})
